import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import DocumentTitle from "react-document-title"

import {
  PageHeader, Row, Col, ControlLabel,
  Form, FormGroup, FormControl
} from 'react-bootstrap'

import TranslateLink from '../components/TranslateLink.jsx'
import { docPageStyle } from '../containers/PageStyles'
import MarkdownField from '../lib/MarkdownField.jsx'
import RouteEditor from '../routes/RouteEditor.jsx'
import { getRouteLength } from '../../lib/TripTools.js'
import { createActivity, updateActivity } from '../ducks/activities'

import { createBlock, updateBlock } from '../ducks/blocks'
import * as RouteActions from '../ducks/routes'
import { getText } from '../lib/text.js'

import {
  getReadyState,
  getBlockForUrl,
  getBlocksList,
  getCitiesIdList,
  getActivitiesList,
  getSortedExpenses,
  getRouteForBlock,
} from '../selectors'

type Props = {
  ready: boolean,
  onlyBlockId: string,

  routeParams: { id: string },
  activities: Object,
  onUpdate: (string, Object) => void,
  onActivityCreate: (Object, Function) => void,
  onActivityUpdate: (string, string, any) => void,

  optionSelection: Object[]
}

class Block extends React.PureComponent
{
  props: Props

  selectedBlockId() {
    return this.props.onlyBlockId || this.props.routeParams.id
  }

  handleChange (k, v) {
    this.props.onUpdate(this.selectedBlockId(), { [k]: v })
  }

  getCityPostLabel() {
    const { Cities } = this.props
    const block = this.props.block
    const chineseCity = block.city && Cities[block.city] && Cities[block.city].chinese

    if (!block.city) {
      return (<span style={{ color: "red" }}>Es necesario indicar la ciudad</span>)
    }
    else if (!chineseCity) {
      return (<span>(ciudad no traducida; <Link to="/private/cities">ir a "Ciudades"</Link>)</span>)
    }
    else return `(${chineseCity})`
  }


  /*** reordering ***/

  render() {
    if (!this.props.ready) {
      return (<div>Loading...</div>)
    }

    const { activities, Cities } = this.props


    const block = this.props.block
    if (!block) {
      return <span>{"Loading... (if stuck on this page for >5s, something has gone south.)"}</span>
    }

    const id = block._id
    const chineseCity = Cities[block.city] && Cities[block.city].chinese
    const route = this.props.route

    return (
      <div id="admin-block-editor" style={docPageStyle({maxWidth: 1150})}>
        <DocumentTitle title= {`${getText("Plantilla")}: ${block.name}`} />
        <Link to="/private/blocks" style={{fontWeight: "bold", fontSize: "15px"}}>
          {`< ${getText("Volver a la lista")}`}
        </Link>

        <PageHeader>{block.name} <small>{getRouteLength(route)} {getText("días")}</small></PageHeader>

        <Row>

          <Col md={7}>
            {/* editable fields */}
            <Form inline>
              <div>
                <FormGroup>
                  <ControlLabel style={{width: 150}}>{getText("spanish_name")}:</ControlLabel>
                  <FormControl
                    type="text"
                    value={block.name}
                    bsSize="small"
                    onChange={evt => this.handleChange("name", evt.target.value)}
                  />
                </FormGroup>
              </div>
              <div>
                <FormGroup>
                  <ControlLabel style={{width: 150}}>{getText("chinese_title")}:</ControlLabel>
                  <FormControl
                    type="text"
                    value={block.title}
                    bsSize="small"
                    onChange={evt => this.handleChange("title", evt.target.value)}
                  />
                </FormGroup>
                <TranslateLink text={block.title} />
              </div>
            </Form>
          </Col>

          <Col md={5}>
            <MarkdownField
              label={getText("notas_spanish")}
              value={block.note}
              placeholder={`*${getText("Sin notas; click para editar")}*`}
              onChange={text => this.handleChange("note", text)}
            />
          </Col>

        </Row>

        {/* Content */}
        <h3>{getText("Contenido de la plantilla")}:</h3>
        <RouteEditor
          id={block._id}
          route={route}
          blockTemplates={this.props.blockTemplates}
          Cities={Cities}
          Activities={activities}
          Routes={this.props.routes}

          addBlock={(id, route, itarget) => this.props.addBlock(id, route, itarget)}
          replaceWithBlock={(id, block) => this.props.replaceWithBlock(route._id, block, this.props.routes[block.route])}

          move={this.props.move}
          addActivity={this.props.addActivity}
          addCity={this.props.addCity}
          addDay={this.props.addDay}
          addExpense={this.props.addExpense}
          addNote={this.props.addNote}
          editItem={this.props.editItem}
          updateExpenses={this.props.updateExpenses}
          remove={this.props.remove}
          multiMove={this.props.multiMove}
          CitiesList={this.props.CitiesList}
          AliveActivitiesList={this.props.AliveActivitiesList}
          blockTemplatesList={this.props.blockTemplatesList}
          createBlock={this.props.createBlock}
          repeatExpense={this.props.repeatExpense}
          moveItem={this.props.moveItem}
          ExpensesList={this.props.ExpensesList}

          isTemplate={true}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  ready: getReadyState(state, props),

  block: getBlockForUrl(state, props),
  route: getRouteForBlock(state, props),

  activities:     state.activities,
  routes:     state.routes,
  Cities: state.cities,

  CitiesList: getCitiesIdList(state, props),
  AliveActivitiesList: getActivitiesList(state, props),
  ExpensesList: getSortedExpenses(state, props),
  blockTemplatesList: getBlocksList(state, props)
})

const mapDispatchToProps = (dispatch) => ({
  onUpdate: (id, changes) => dispatch(updateBlock(id, changes)),
  onActivityCreate: (initials, cb) => dispatch(createActivity(initials, cb)),
  onActivityUpdate: (id, k, v) => dispatch(updateActivity(id, {[k]: v})),

  addActivity:     (id, a, itarget)    => dispatch(RouteActions.addActivity(id, a, itarget || null)),
  addBlock:        (id, r, itarget)    => dispatch(RouteActions.addBlock(id, r, itarget || null)),
  addCity:         (id, city, itarget) => dispatch(RouteActions.addCity(id, city, itarget || null)),
  addDay:          (id, itarget)       => dispatch(RouteActions.addDay(id, itarget || null)),
  addExpense:      (id, x, itarget)    => dispatch(RouteActions.addExpense(id, x, itarget || null)),
  editItem:        (id, itarget, k, v) => dispatch(RouteActions.editItem(id, itarget, {[k]: v})),
  move:            (id, itarget, dir)  => dispatch(RouteActions.updateContent(id, dir, itarget)),
  moveItem:        (id, i, newPos)     => dispatch(RouteActions.moveItem(id, i, newPos)),
  multiMove:       (id, ii, dir)       => dispatch(RouteActions.multiMove(id, dir, ii)),
  remove:          (id, itarget, opt)  => dispatch(RouteActions.remove(id, itarget, opt)),
  repeatExpense:   (id, isrc, idst)    => dispatch(RouteActions.repeatExpense(id, isrc, idst)),
  updateExpenses:  (id, expenses)      => dispatch(RouteActions.updateExpenses(id, expenses)),

  addNote:         (id, itarget)       => dispatch(RouteActions.addNote(id, itarget || null)),

  replaceWithBlock: (id, b, br) => dispatch(RouteActions.replaceWithBlock(id, b, br)),

  createBlock: (name, content) => dispatch(createBlock({ name, content, note: `Ruta importada` })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Block)
